export const storeGetters = {

  /** Get local config */
  config(state) {
    return state.clientConfig
  },

  env(state) {
    return (name) => state.envVars['VITE_' + name]
  },

  token(state) {
    return state.auth.token
  },

  user(state) {
    return state.auth.user
  },

  userId(state) {
    return state.auth?.user?.id ?? null;
  },

  apiPath(state) {
    return state.clientConfig.server.routes.api
  },

  /** Available tracks, loaded once at boot (see loadBootstrap). */
  tracks(state) {
    return state.serverConfig?.tracks ?? []
  },

  /** Available cars, loaded once at boot (see loadBootstrap). */
  cars(state) {
    return state.serverConfig?.cars ?? []
  },

  /**
   * Races a driver has to run before their rating stops being marked as provisional (the "?" in the
   * standings). A server rule (config/ranking.php), delivered by the bootstrap: never duplicated.
   */
  provisionalRaces(state) {
    return state.serverConfig?.ranking?.provisionalRaces ?? 10
  },

  isLoading: (state) => {
    return (key) => {
      return state.system.loading[key]
    }
  },

  currentLanguage(state) {
    return state.settings.language
  }

}